
import React from 'react';

export const Footer: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#050B14] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          {/* Company Info */}
          <div className="space-y-6">
            <div className="flex items-center">
              <img 
                src="https://public.readdy.ai/ai/img_res/18fbafa5-fe56-4ee6-aedd-9bee74ac04df.png" 
                alt="BALESTRA Logo"
                className="h-8 w-auto"
              />
              <span className="ml-3 text-lg font-bold">BALESTRA</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Enterprise VPN solutions for modern businesses. Protecting digital privacy with advanced security technology.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-6">
            <h4 className="text-gray-300 text-xs uppercase font-bold tracking-wider">
              QUICK LINKS
            </h4>
            <div className="space-y-5">
              <button
                onClick={() => scrollToSection('home')}
                className="block text-white hover:text-[#00D4FF] transition-colors duration-300"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('vpn')}
                className="block text-white hover:text-[#00D4FF] transition-colors duration-300"
              >
                VPN Features
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="block text-white hover:text-[#00D4FF] transition-colors duration-300"
              >
                Contact Us
              </button>
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-6">
            <h4 className="text-gray-300 text-xs uppercase font-bold tracking-wider">
              CONTACT
            </h4>
            <div className="space-y-4">
              <a 
                href="mailto:information@balestradoocacak.com"
                className="block text-white text-sm hover:text-[#00D4FF] transition-colors duration-300"
              >
                information@balestradoocacak.com
              </a>
              <a 
                href="tel:+19855318157"
                className="block text-white text-sm hover:text-[#00D4FF] transition-colors duration-300"
              >
                +1 985 531 8157
              </a>
              <div className="text-gray-400 text-sm">
                <div>Stara Pruga 13</div>
                <div>Preljina, 525305</div>
                <div>Serbia</div>
              </div>
            </div>
          </div>

          {/* Connect */}
          <div className="space-y-6">
            <h4 className="text-gray-300 text-xs uppercase font-bold tracking-wider">
              CONNECT
            </h4>
            <div className="space-y-5">
              <a 
                href="#" 
                className="block text-white hover:text-[#00D4FF] transition-colors duration-300"
                rel="nofollow"
              >
                LinkedIn
              </a>
              <a 
                href="#" 
                className="block text-white hover:text-[#00D4FF] transition-colors duration-300"
                rel="nofollow"
              >
                Twitter
              </a>
              <a 
                href="#" 
                className="block text-white hover:text-[#00D4FF] transition-colors duration-300"
                rel="nofollow"
              >
                Facebook
              </a>
            </div>
          </div>
        </div>

        {/* Brand Statement */}
        <div className="mt-16 pt-8 border-t border-gray-800">
          <div className="text-center">
            <div className="text-[#C8B8A0] font-bold text-6xl lg:text-8xl tracking-tight mb-4">
              BALESTRA
            </div>
            <div className="text-gray-400 text-sm">
              © 2024 BALESTRA DOO CACAK. All rights reserved. | 
              <a href="https://readdy.ai/?origin=logo" className="hover:text-[#00D4FF] transition-colors duration-300 ml-1" rel="nofollow">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
